// src/components/PaymentForm.js
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const styles = `
.payment-form { width: 100%; }
.payment-form .radio-group {
  display: grid;
  gap: 10px;
  margin-bottom: 8px;
}
.payment-form .radio-label {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid #e6e6ea;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: box-shadow .15s ease, border-color .15s ease;
}
.payment-form .radio-label:hover {
  box-shadow: 0 2px 10px rgba(0,0,0,.04);
  border-color: #dedee8;
}
.payment-form .radio-label input[type="radio"] {
  width: 18px; height: 18px;
  accent-color: #5a4ae3;
}

.payment-form .bank-transfer-box {
  margin-top: 12px;
  padding: 16px;
  border-radius: 10px;
  background: #f9f9ff;
  border: 1px solid #e0e0f0;
  line-height: 1.5;
}
.payment-form .bank-title {
  margin: 0 0 10px;
  color: #5a4ae3;
  font-size: 1.05rem;
  font-weight: 600;
}
.payment-form .bank-transfer-box p { margin: 6px 0; }
.payment-form .muted {
  color: #666;
  font-size: 0.9rem;
  margin-top: 8px;
}
`;

const PaymentForm = ({ amount, onPaymentMethodChange, defaultMethod = 'bank' }) => {
  const { t } = useTranslation('registration');
  const [method, setMethod] = useState(defaultMethod);

  useEffect(() => {
    onPaymentMethodChange(method);
  }, [method, onPaymentMethodChange]);

  return (
    <div className="payment-form">
      {/* CSS in-file */}
      <style>{styles}</style>

      <div className="radio-group">
        <label className="radio-label">
          <input
            type="radio"
            name="payment"
            value="cash"
            checked={method === 'cash'}
            onChange={() => setMethod('cash')}
          />
          <span>{t('payment.methods.cash')}</span>
        </label>

        <label className="radio-label">
          <input
            type="radio"
            name="payment"
            value="bank"
            checked={method === 'bank'}
            onChange={() => setMethod('bank')}
          />
          <span>{t('payment.methods.bank')}</span>
        </label>
      </div>

      {method === 'bank' && (
        <div className="bank-transfer-box">
          <h4 className="bank-title">{t('payment.wire.title')}</h4>
          <p><strong>{t('payment.wire.beneficiary')}:</strong> BEUNIT ASBL (MKD studio)</p>
          <p><strong>{t('payment.wire.iban')}:</strong> BE80&nbsp;7340&nbsp;4589&nbsp;7577</p>
          <p><strong>{t('payment.wire.bic')}:</strong> KREDBEBBXXX</p>
          <p><strong>{t('payment.wire.amount')}:</strong> {amount}€</p>
          <p><strong>{t('payment.wire.reference')}:</strong> {t('payment.wire.referenceValue')}</p>
          <p className="muted">{t('payment.wire.after')}</p>
        </div>
      )}
    </div>
  );
};

PaymentForm.propTypes = {
  amount: PropTypes.number.isRequired,
  onPaymentMethodChange: PropTypes.func.isRequired,
  defaultMethod: PropTypes.oneOf(['bank', 'cash'])
};

export default PaymentForm;
